<template>
  <div v-if="!isEdit" :name="`${name}Container`">
    {{ value }}
    <button class="btn btn-link change-button pl-0" @click.prevent="isEdit = true" :disabled="!isEditable">
      <span class="icon-pencil3 ms-4" />
      {{ value ? $t('change') : $t('add') }}
    </button>
  </div>
  <ValidationField v-else :type="type" v-bind="$attrs" :value="currentValue" v-slot="{ valid, validityClass }">
    <div class="input-group" :class="validityClass">
      <input
        :type="type"
        :name="name"
        class="form-control"
        v-model.trim="currentValue"
      >
      <div class="input-group-append">
        <button class="btn btn-default" type="button" :disabled="!valid" @click="save">
          {{ $t('save') }}
        </button>
      </div>
    </div>
  </ValidationField>
</template>

<script>
import ValidationField from './ValidationField';

export default {
  props: {
    value: String,
    type: String,
    name: String,
    isEditable: {
      type: Boolean,
      default: true,
    },
    isMonitoring: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ValidationField,
  },
  data: () => ({
    isEdit: false,
    currentValue: '',
  }),
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.currentValue = value;
      },
    },
    isEditable(val) {
      if (this.isMonitoring) {
        if (!val) {
          this.currentValue = '';
          this.isEdit = false;
        } else if (!this.value) {
          this.isEdit = true;
        }
      }
    },
  },
  methods: {
    save() {
      this.isEdit = false;
      if (this.value !== this.currentValue || !this.currentValue) {
        this.$emit('save', this.currentValue);
      }
    },
  },
};
</script>
